<app-dialog-header [title]="'Detalhes do pedido #' + order.id"></app-dialog-header>

<mat-dialog-content>
  <div class="modal-content">
    <div class="d-grid gap-3">
      <div class="client-data">
        <div class="container d-flex justify-content-between">
          <p class="h6 text-dark">Data da compra:</p>
          <p class="h6 .text-secondary">{{ order.paid_at | date: "dd/MM/yyyy HH:mm" }}</p>
        </div>
        <div class="container d-flex justify-content-between">
          <p class="h6 text-dark">Status:</p>
          <p class="h6 .text-secondary">{{ order.payment_status | orderPaymentStatus }}</p>
        </div>
        <div class="container d-flex justify-content-between">
          <p class="h6 text-dark">Nome:</p>
          <p class="h6 .text-secondary">{{ customerName }}</p>
        </div>
        <div class="container d-flex justify-content-between">
          <p class="h6 text-dark">Email:</p>
          <p class="h6 .text-secondary">{{ customerEmail }}</p>
        </div>
      </div>
      <div class="container d-grid">
        <p class="h5" style="color: #7c0084">Resumo da compra</p>
        <div style="overflow: auto">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Portador(a)</th>
                <th scope="col">Email</th>
                <th scope="col">Tipo</th>
                <th scope="col">Status</th>
                <th scope="col">Valor</th>
                <th scope="col">{{ order.pdv ? "Taxa de plataforma" : "Taxa" }}</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of order.tickets">
                <th scope="row">{{ ticket.id }}</th>
                <td>{{ getHolderName(ticket) }}</td>
                <td>{{ ticket.user_email?.trim() || "Não informado" }}</td>
                <td>{{ ticket.title }}</td>
                <td>{{ getTicketStatus(ticket) }}</td>
                <td>{{ ticket.price | currency: "BRL" : true }}</td>
                <td>
                  {{
                    getTicketFee(ticket) === null ? "Não informada" : (getTicketFee(ticket) | currency: "BRL" : true)
                  }}
                  @if (order.pdv && getTicketFee(ticket) !== null) {
                    <small class="d-block">{{
                      (ticket.pdv_customer_fee_cents ?? 0) > 0 ? "Acrescida ao ingresso" : "Absorvida pelo produtor"
                    }}</small>
                  }
                </td>
                <td>{{ getTicketTotal(ticket) | currency: "BRL" : true }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      @if (order.pdv) {
        <p class="h6 text-dark">
          {{
            hasPdvCustomerFee
              ? "PDV antecipado: a taxa de plataforma foi acrescentada ao ingresso. O total inclui esse acréscimo."
              : "A taxa de plataforma desta compra foi absorvida pelo produtor e não é somada ao total."
          }}
          No PDV não há taxa de processamento.
        </p>
      }
      @if (order.coupon) {
        <div class="container d-flex justify-content-end">
          <p class="h6" style="color: #7c0084">
            Cupom {{ order.coupon.code }} — desconto
            {{ order.coupon.discount_amount | currency: "BRL" : true }}
          </p>
        </div>
      }
      <div class="container d-flex justify-content-end">
        <p class="h5 text-bold" style="color: #7c0084">
          Total do pedido: {{ order.total_amount | currency: "BRL" : true }}
        </p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button type="button" styleType="secondary" (click)="dialogRef.close()"> Fechar </app-button>
</mat-dialog-actions>
